import queryString from 'query-string';

import { Search } from '@packages/types/auth/search';

import * as api from 'js/common/services/api';
import { RequestParams } from 'js/common/context/RequestParamsContext';
import { justLoggedInRedirect } from 'js/common/utils/authRedirectUtils';

interface ProcessAuthParams {
  requestParams: RequestParams;
  location: Pick<Location, 'search'>;
  windowLocation?: Pick<Location, 'assign'>;
}

export default async function processAuth({
  requestParams,
  location,
  windowLocation = window.location,
}: ProcessAuthParams) {
  const parsedSearchLocation = queryString.parse(location.search) as Search;
  const { uId, email, csrfToken, csrfTime, needsMfa, username, idp, personalizationWizardRedirect } =
    parsedSearchLocation;

  if (uId) {
    justLoggedInRedirect({
      username,
      email,
      csrfTime,
      csrfToken,
      baasCentralUrl: requestParams.baasCentralUrl,
      centralUrl: requestParams.centralUrl,
      needsMfa: needsMfa === 'true',
      query: parsedSearchLocation,
      windowLocation,
      segmentDefaultUserId: requestParams.segmentDefaultUserId,
      personalizationWizardRedirect,
    });
  } else if (idp) {
    const clientState = parsedSearchLocation;
    delete clientState.idp;
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ idpId: string; clientState: Se... Remove this comment to see the full error message
    const { loginRedirect } = await api.auth.startOidc({ idpId: idp, clientState });
    windowLocation.assign(loginRedirect);
  } else {
    windowLocation.assign('/');
  }
}
